<div class="container">
	<div *ngIf="!isReadOnly" [ngClass]="{'new-round':type === NEW_TYPE,'round':type === DEFAULT_TYPE}">
		<input (ngModelChange)="setCheckBox($event)" [(ngModel)]="value" id="{{id}}" type="checkbox"/>
		<label [for]="id"></label>
	</div>
	<div *ngIf="isReadOnly" [ngClass]="{'new-round':type === NEW_TYPE,'round':type === DEFAULT_TYPE}">
		<input (click)="setReadOnlyCheckBox($event)" [ngModel]="value" id="{{id}}"
			   type="checkbox"/>
		<label [for]="id"></label>
	</div>
</div>
